module.exports = __webpack_public_path__ + "img/netstoresessionnumber.a673cd4f.png";